






























import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppSelector from '@/components/AppSelector.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import { IInsuredContactInput } from '@/modules/Insured/interfaces/insured-form'
import { educationValues, maritalValues } from '@/modules/Insured/helpers/insured'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class InsuredFormContact extends Vue {
  @Prop({ type: Object as () => IInsuredContactInput }) value!: IInsuredContactInput

  educationValues = educationValues
  maritalValues = maritalValues

  validate () {
    return (this.$refs.form as Vue & { validate: () => boolean }).validate()
  }
}
